export default __webpack_public_path__ + "static/media/vip.c5f0ede7.svg";